import PropTypes from 'prop-types';
import React from 'react';

// Emoji faces for the 1-5 emoji rating, as inline SVG so they look the same on
// every OS (system emoji fonts differ). Artwork: Twemoji
// (https://github.com/jdecked/twemoji, graphics CC-BY 4.0).

// 😠
export const AngryFace = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={size} height={size} aria-hidden="true">
    <path fill="#FFCC4D" d="M36 18c0 9.941-8.059 18-18 18-9.94 0-18-8.059-18-18C0 8.06 8.06 0 18 0c9.941 0 18 8.06 18 18" />
    <path fill="#664500" d="M25.485 29.879C25.44 29.7 24.317 25.5 18 25.5c-6.318 0-7.44 4.2-7.485 4.379-.055.217.043.442.237.554.195.109.439.079.6-.077.019-.019 1.954-1.856 6.648-1.856s6.63 1.837 6.648 1.855c.096.095.224.145.352.145.084 0 .169-.021.246-.064.196-.112.294-.339.239-.557zm-9.778-12.586C12.452 14.038 7.221 14 7 14c-.552 0-.999.447-.999.998-.001.552.446 1 .998 1.002.029 0 1.925.022 3.983.737-.593.64-.982 1.634-.982 2.763 0 1.934 1.119 3.5 2.5 3.5s2.5-1.566 2.5-3.5c0-.174-.019-.34-.037-.507.013 0 .025.007.037.007.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414zM29 14c-.221 0-5.451.038-8.707 3.293-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293.013 0 .024-.007.036-.007-.016.167-.036.333-.036.507 0 1.934 1.119 3.5 2.5 3.5s2.5-1.566 2.5-3.5c0-1.129-.389-2.123-.982-2.763 2.058-.715 3.954-.737 3.984-.737.551-.002.998-.45.997-1.002-.001-.551-.447-.998-.999-.998z" />
  </svg>
);

// 😟
export const WorriedFace = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={size} height={size} aria-hidden="true">
    <path fill="#FFCC4D" d="M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18" />
    <path fill="#664500" d="M23.485 28.879C23.474 28.835 22.34 24.5 18 24.5s-5.474 4.335-5.485 4.379c-.053.213.044.431.232.544.188.112.433.086.596-.06.009-.008 1.013-.863 4.657-.863 3.59 0 4.617.83 4.656.863.095.09.219.137.344.137.084 0 .169-.021.246-.064.196-.112.294-.339.239-.557zM29 12c-5.554 0-7.802-4.367-7.895-4.553-.247-.494-.047-1.095.447-1.342.493-.247 1.092-.048 1.34.443C22.967 6.694 24.713 10 29 10c.553 0 1 .448 1 1s-.447 1-1 1zM7 12c-.552 0-1-.448-1-1s.448-1 1-1c5.083 0 5.996-3.12 6.033-3.253.145-.528.692-.848 1.219-.709.53.139.851.673.718 1.205C14.921 7.437 13.704 12 7 12z" />
    <ellipse fill="#664500" cx="12" cy="16.5" rx="2.5" ry="3.5" />
    <ellipse fill="#664500" cx="24" cy="16.5" rx="2.5" ry="3.5" />
  </svg>
);

// 😐
export const NeutralFace = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={size} height={size} aria-hidden="true">
    <path fill="#FFCC4D" d="M36 18c0 9.941-8.059 18-18 18-9.94 0-18-8.059-18-18C0 8.06 8.06 0 18 0c9.941 0 18 8.06 18 18" />
    <ellipse fill="#664500" cx="11.5" cy="16.5" rx="2.5" ry="3.5" />
    <ellipse fill="#664500" cx="24.5" cy="16.5" rx="2.5" ry="3.5" />
    <path fill="#664500" d="M25 26H11c-.552 0-1-.447-1-1s.448-1 1-1h14c.553 0 1 .447 1 1s-.447 1-1 1z" />
  </svg>
);

// 🙂
export const SlightlySmilingFace = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={size} height={size} aria-hidden="true">
    <circle fill="#FFCC4D" cx="18" cy="18" r="18" />
    <path fill="#664500" d="M10.515 23.621C10.56 23.8 11.683 28 18 28c6.318 0 7.44-4.2 7.485-4.379.055-.217-.043-.442-.237-.554-.195-.111-.439-.078-.6.077C24.629 23.163 22.694 25 18 25s-6.63-1.837-6.648-1.855C11.256 23.05 11.128 23 11 23c-.084 0-.169.021-.246.064-.196.112-.294.339-.239.557z" />
    <ellipse fill="#664500" cx="12" cy="13.5" rx="2.5" ry="3.5" />
    <ellipse fill="#664500" cx="24" cy="13.5" rx="2.5" ry="3.5" />
  </svg>
);

// 😁
export const GrinningFace = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={size} height={size} aria-hidden="true">
    <path fill="#FFCC4D" d="M36 18c0 9.941-8.059 18-18 18-9.94 0-18-8.059-18-18C0 8.06 8.06 0 18 0c9.941 0 18 8.06 18 18" />
    <path fill="#664500" d="M16 18c-.419 0-.809-.265-.949-.684C14.848 16.717 14.034 15 13 15c-1.062 0-1.888 1.827-2.051 2.316-.175.523-.738.808-1.265.632-.524-.174-.807-.741-.632-1.265C9.177 16.307 10.356 13 13 13s3.823 3.307 3.949 3.684c.175.524-.108 1.091-.632 1.265-.106.034-.213.051-.317.051zm10 0c-.419 0-.809-.265-.948-.684C24.849 16.717 24.033 15 23 15c-1.062 0-1.889 1.827-2.052 2.316-.175.523-.736.808-1.265.632-.523-.174-.807-.741-.632-1.265C19.177 16.307 20.355 13 23 13s3.823 3.307 3.948 3.684c.175.524-.108 1.091-.632 1.265-.105.034-.212.051-.316.051zm-8 4c-3.623 0-6.027-.422-9-1-.679-.131-2 0-2 2 0 4 4.595 9 11 9 6.404 0 11-5 11-9 0-2-1.321-2.132-2-2-2.973.578-5.377 1-9 1z" />
    <path fill="#FFF" d="M9 23s3 1 9 1 9-1 9-1-1.344 6.75-9 6.75S9 23 9 23z" />
    <path fill="#664500" d="M18 27.594c-3.596 0-6.272-.372-7.937-.745l-.825-1.871c.823.312 3.889.897 8.763.897 4.954 0 8.037-.616 8.864-.938l-.701 1.842c-1.634.38-4.419.815-8.164.815z" />
  </svg>
);

const facePropTypes = { size: PropTypes.number };
const faceDefaultProps = { size: 28 };

AngryFace.propTypes = facePropTypes;
AngryFace.defaultProps = faceDefaultProps;

WorriedFace.propTypes = facePropTypes;
WorriedFace.defaultProps = faceDefaultProps;

NeutralFace.propTypes = facePropTypes;
NeutralFace.defaultProps = faceDefaultProps;

SlightlySmilingFace.propTypes = facePropTypes;
SlightlySmilingFace.defaultProps = faceDefaultProps;

GrinningFace.propTypes = facePropTypes;
GrinningFace.defaultProps = faceDefaultProps;
